import { HotelBedCatalogData } from '../shared/index';

export const TASK_COMPLETE_STATES: string[] = ['AVAILABLE', 'COMPLETE-WITH-ERROR', 'NOTAVAILABLE'];

/**
 * state yang sudah punya data. jadi panel sudah boleh me render
 */
export const HAVE_DATA_STATES: string[] = ['AVAILABLE', 'PARTIALY-AVAILABLE', 'COMPLETE-WITH-ERROR'];
/**
 * state yang perlu pengecekan
 */
export const NEED_RECHECK_STATES: string[] = ['REQUESTING', 'PARTIALY-AVAILABLE'];
// ['REQUESTING' ,  'AVAILABLE'  , 'NOTAVAILABLE' ,  'PARTIALY-AVAILABLE'  , 'COMPLETE-WITH-ERROR'].
/**
 * interface untuk checker result
 */
export interface HotelRequestCheckerTool {
    /**
     * start timer/watcher untuk mengecek data
     * @param reqKey 
     */
    runCheck(reqKey: string): any;

    /**
     * ini kalau memang perlu listen akan memanggil : runCheck. kalau memang data category nya ready, ini akan kirim juga ke handler data
     * 
     */
    runCheckWithReqAvailibilityHeaderData(reqAvailableHeader: HotelBedCatalogData.ReqHotelAvailable): any;
    /**
     * reset checker
     */
    stopChecker(): any;
} 


// WEBPACK FOOTER //
// ./src/hotels/HotelRequestCheckerTool.ts